t = require('app/scripts/views/internal/teacup-with-helpers')('header_warning_password')

module.exports = ->
  t.p '.u-bottom', ->
    t.format 'we-ve-automatically-created-an-account-for-email-with-the-username-username', { email: t.mustacheVar('email'), username: t.mustacheVar('username') }
    t.a '.quiet.js-change-password', { href: '/my/account' }, ->
      t.format 'add-a-password'
